import Image from 'next/image';
import Link from 'next/link';
import {Card, SingleTableSpecifications, Tabs2Specifications} from './Tab2Specifications.jsx';
import {Tabs1Description} from './Tab1Description.jsx';
import {tryJson} from '@helpers/common/json.mjs';
import {ReviewStarsFromDb} from '@components/product/reviews/review-stars-from-db';

export const buildDescriptionTab = (metaData, selectedVariant) => {
  const tabDescriptionBodyValue = metaData?.tab_description_body?.value ?? metaData.description;
  const tabDescriptionTableValue =
    metaData?.tab_description_table?.value ?? metaData.descriptionTable;
  // console.log('[buildDescriptionTab] selectedVariant', selectedVariant);

  return [
    <Tabs1Description
      key={1}
      tabDescriptionTableValue={tabDescriptionTableValue}
      tabDescriptionBodyValue={tabDescriptionBodyValue}
      selectedVariant={selectedVariant}
    />
    // <DescriptionNotes value={value}/>
  ];
};

export const buildSpecificationTab = (metaData) => {
  const value = metaData?.tab_specifications?.value;
  // console.log({value})
  return [<Tabs2Specifications key={1} value={value}/>];
};

export const buildBundleComponentItemsTab = (product) => {
  const childProducts = product?.childProducts;
  const mergedSpecs = childProducts?.reduce((acc, childProduct) => {
    const specs =
      childProduct?.specifications?.specs?.map((spec) => ({
        ...spec,
        title: `${spec.title} (${childProduct.sku})`
      })) || [];
    return [...acc, ...specs];
  }, []);
  const mergedSpecsJson = {specs: mergedSpecs};

  return [
    <TabBundleItems key={2} childProducts={childProducts}/>,
    <Tabs2Specifications key={3} value={mergedSpecsJson}/>
  ];
};

export function TabBundleItems({childProducts}) {
  // console.log(childProducts);
  const maxCols = childProducts?.length >= 3 ? 3 : childProducts?.length;
  return (
    <div
      id='TabBundleItems'
      className={`grid grid-cols-2 lg:grid-cols-${maxCols} p-2 border border-neutral-400 rounded-md`}>
      {childProducts?.map((childProduct, index) => {
        const productTitle = childProduct?.productTitle;
        const firstImage = childProduct?.images[0];
        return (
          <>
            <Link
              href={childProduct.childHandle}
              key={`tab-bundle-item-${index}`}
              className='flex flex-col items-center justify-between gap-0 relative'>
              <div className={'flex flex-col items-center'}>
                {firstImage ? (
                  <Image
                    src={firstImage?.url}
                    alt={`Image for ${productTitle}`}
                    styles={{backgroundSize: '125%'}}
                    width='150'
                    height='150'
                  />
                ) : null}

                <div className='text-center text-sm lg:text-base'>{productTitle}</div>
              </div>
              <div className='flex md:justify-center mt-1 md:mt-3 md:mb-2'>
                {childProduct?.review_avg_rating ? (
                  <ReviewStarsFromDb
                    avgScore={childProduct?.review_avg_rating}
                    count={childProduct?.review_count}
                    size={14}
                  />
                ) : null}
              </div>

              {index > 0 ? (
                <div className={`absolute -left-[2rem] top-[2rem] w-20 h-20`}>
                  <div className='flex flex-col items-center justify-between gap-0 relative'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 58.96 51.5'>
                      <path
                        fill={'#000'}
                        d='M58.48 24.49c.38.35.53.65.45.89-.08.25-.34.23-.79-.05-.3-.14-.47-.19-.51-.16-.04.04-.06.23-.06.58 0 .98-.15 1.46-.45 1.46-.08 0-.11-.28-.11-.84.07-.56.04-.77-.11-.63-.23.21-.34.38-.34.52 0 .21-.11.31-.34.31-.38 0-.45-.1-.23-.31.3-.28-.04-.42-1.02-.42-.91 0-1.29-.1-1.13-.31.15-.28.07-.49-.23-.63-.15-.07-.19-.03-.11.1.23.21.11.45-.34.73-.3.42-.45.66-.45.73s-.08.1-.23.1v-.1c-.23-.21-.45-.31-.68-.31s-.15.1.23.31c.08.07.13.1.17.1s.09.04.17.1c-.15 0-.38.14-.68.42-.38.14-.53.17-.45.1.15-.14.04-.1-.34.1-.38.28-.91.44-1.59.47-.68.04-1.1-.09-1.25-.37 0-.14-.02-.21-.06-.21s-.06.07-.06.21c0 .21-.15.31-.45.31s-.45-.1-.45-.31-.11-.17-.34.1c-.3.28-.64.42-1.02.42-.23 0-.78.02-1.64.05-.87.04-1.84.12-2.89.26-1.06.14-2.08.25-3.06.31-.98.07-1.67.1-2.04.1-.68 0-1.23.04-1.65.1-.42.07-.81.61-1.19 1.62-.38 1.01-.89 2.69-1.53 5.02-.64 2.34-1.53 5.77-2.67 10.3-.98 3.84-1.63 5.75-1.93 5.75s-.3-.31 0-.94c0-.21.04-.45.11-.73.07-.28.11-.49.11-.63s.09-.59.28-1.36c.19-.77.4-1.6.62-2.51.38-1.46.58-2.41.62-2.82.04-.42-.02-.63-.17-.63s-.27.02-.34.05c-.08.04-.04.05.11.05v.47c0 .25-.08.51-.23.78-.08.35-.15.7-.23 1.05-.08.35-.11.63-.11.84 0 .28-.15.77-.45 1.46-.15.42-.3.91-.45 1.46-.08.28-.13.58-.17.89-.04.31-.13.75-.28 1.31-.15 0-.23.1-.23.31 0 .14-.13.21-.4.21s-.47-.07-.62-.21c-.08-.07-.34-.1-.79-.1-.3 0-.45-.28-.45-.84s.07-.84.23-.84c.23 0 .26-.24.11-.73-.15-.42-.11-.7.11-.84.3-.14.45-.73.45-1.78.15-.91.32-1.6.51-2.09.19-.49.36-.52.51-.1.15.35.26.52.34.52.15 0 .23-.1.23-.31s-.11-.38-.34-.52c-.23-.21-.34-.47-.34-.78s.07-.54.23-.68c.15-.14.23-.59.23-1.36 0-.35.04-.68.11-.99.07-.31.15-.58.23-.78.15-.28.23-.59.23-.94-.15-.28-.34-.03-.57.73-.3.91-.49 1.4-.57 1.46 0 .21-.08.59-.23 1.15 0 .63-.19 1.05-.57 1.26-.23.28-.27.38-.11.31.23-.14.34-.12.34.05s-.19.44-.57.78c-.23.21-.47.66-.74 1.36-.27.7-.32 1.22-.17 1.57 0 .21-.19.66-.57 1.36-.3.56-.47.91-.51 1.05-.04.14-.06.49-.06 1.05 0 .42-.15.52-.45.31-.38-.14-.76-.14-1.13 0-.45.21-.83.25-1.13.1-.08-.07-.34-.14-.79-.21-.45-.07-.95-.17-1.48-.31-.61-.14-1.1-.24-1.47-.31-.38-.07-.61-.1-.68-.1-.45-.42-.27-2.16.57-5.23.23-.91.51-2.02.85-3.35.34-1.32.62-2.51.85-3.56.23-1.11.45-2.14.68-3.09.23-.94.38-1.55.45-1.83.15-.77.19-1.15.11-1.15 0-.07-.51-.03-1.53.1-1.02.14-2.14.31-3.35.52-1.21.21-2.35.42-3.4.63-1.06.21-1.66.35-1.82.42-.45.21-.79.21-1.02 0l-.11-.42c.3 0 .15-.14-.45-.42-.15-.14-.32-.35-.51-.63s-.36-.56-.51-.84c-.15-.28-.45-.7-.91-1.26-.45-.56-.95-1.11-1.47-1.67-1.51-1.67-2.54-2.91-3.06-3.71-.53-.8-.76-1.38-.68-1.73.23-.84 1.29-1.36 3.18-1.57.38-.07.85-.14 1.42-.21.57-.07 1.15-.14 1.76-.21.53-.07 1.3-.16 2.33-.26s2.06-.23 3.12-.37c.98-.14 1.89-.26 2.72-.37.83-.1 1.36-.16 1.59-.16.15-.07.53-.12 1.13-.16.6-.03 1.21-.09 1.82-.16 1.51-.14 2.4-.28 2.67-.42.26-.14.47-.52.62-1.15.07-.35.13-.63.17-.84.04-.21.06-.35.06-.42l.45-1.67c.15-.49.3-1.06.45-1.73.15-.66.3-1.24.45-1.73.15-.56.36-1.34.62-2.35s.55-2 .85-2.98c.6-2.23 1.04-3.63 1.31-4.18.26-.56.62-.77 1.08-.63.68.14 1.51.52 2.5 1.15.98.63 1.55 1.12 1.7 1.46.15.49.34.66.57.52.3-.14.68.1 1.13.73.38.35.6.56.68.63.07.07.15 0 .23-.21 0-.28.11-.42.34-.42.15 0 .23.07.23.21s.07.21.23.21c.15-.07.49.07 1.02.42s.72.59.57.73c-.08.07-.08.12 0 .16.08.04.19.02.34-.05.75-.28.87.38.34 1.99-.08.35-.13.73-.17 1.15-.04.42-.1.77-.17 1.05 0 .21-.04.58-.11 1.1-.08.52-.19 1.03-.34 1.52-.15.49-.25.98-.28 1.46-.04.49-.06.84-.06 1.05-.08.21-.13.44-.17.68-.04.25-.1.44-.17.58-.15.21-.1.4.17.58.26.17.55.19.85.05.07 0 .68-.03 1.82-.1 1.13-.07 2.46-.1 3.97-.1 3.18-.14 5.65-.23 7.43-.26 1.78-.03 2.74-.12 2.89-.26.07-.07.23.04.45.31.23.28.45.59.68.94.23.35.45.72.68 1.1.23.38.34.68.34.89s.02.42.06.63c.04.21.09.31.17.31.15.14.15.31 0 .52 0 .28.11.45.34.52.3.14.47.33.51.58.04.25-.1.37-.4.37-.15 0-.4.02-.74.05-.34.04-.7.05-1.08.05-.98 0-1.63.14-1.93.42-.3.21-.45.49-.45.84s.19.52.57.52c.61.07 1.36.09 2.27.05.91-.03 1.55-.12 1.93-.26.45-.14.77-.19.96-.16.19.04.43.23.74.58ZM21.71 47.61c.45-.49.6-.98.45-1.46 0-.28-.04-.38-.11-.31-.08.07-.23.38-.45.94-.38.84-.57 1.36-.57 1.57 0 .35.23.1.68-.73Zm.68-2.51c.07-.21.04-.31-.11-.31-.23 0-.34.1-.34.31 0 .14.04.21.11.21 0-.07.04-.1.11-.1s.15-.03.23-.1Zm.79-1.88c.15-.14.08-.28-.23-.42-.3-.07-.45.04-.45.31 0 .14.07.25.23.31.15.07.3 0 .45-.21Zm2.5 3.56c.23-.07.23-.21 0-.42-.23-.14-.4-.17-.51-.1-.11.07-.1.17.06.31.15.28.3.35.45.21Zm0 1.57c.07-.21.11-.42.11-.63-.15-.14-.3-.07-.45.21-.15.28-.15.49 0 .63.07.21.19.14.34-.21Zm1.93-14.02c.07-.49 0-.56-.23-.21-.08.14-.17.37-.28.68s-.19.61-.23.89c-.04.28-.08.52-.11.73-.04.21-.02.28.06.21.15-.07.3-.38.45-.94.08-.21.13-.45.17-.73.04-.28.09-.49.17-.63Zm.11-.84c.23-.21.34-.45.34-.73 0-.35-.08-.5-.23-.47-.15.04-.27.26-.34.68-.15.49-.08.66.23.52Zm2.04 5.75-.34.1c-.15.14-.3.59-.45 1.36l-.11 1.05.45-1.26.45-1.26Zm0-1.05c.15-.14.23-.24.23-.31v-.1c-.08-.14-.15-.17-.23-.1-.08.07-.11.17-.11.31-.23.42-.19.49.11.21Zm10.1-10.98c.15 0 .15-.17 0-.52 0-.42-.08-.56-.23-.42-.08.14-.08.33 0 .58.07.25.15.37.23.37Zm10.55-.84c0-.07-.11-.1-.34-.1-.15 0-.38.07-.68.21 0 .07.11.1.34.1.3 0 .53-.07.68-.21Zm.23-2.41c.23.28.45.44.68.47.23.04.34-.09.34-.37 0-.14-.15-.21-.45-.21-.3.21-.42.04-.34-.52.08-.42 0-.63-.23-.63-.68 0-.68.42 0 1.26Zm1.7 2.72c0-.07.04-.1.11-.1 0 .07-.04.1-.11.1Zm.45-2.93c0-.14.11-.21.34-.21.15 0 .23.07.23.21 0 .21-.08.31-.23.31-.23 0-.34-.1-.34-.31Zm.68 2.82c.15-.14.51-.24 1.08-.31.57-.07.85-.03.85.1 0 .07-.13.23-.4.47-.27.25-.47.37-.62.37-.08 0-.11-.03-.11-.1-.08-.07-.11-.17-.11-.31-.15-.28-.34-.35-.57-.21-.15.07-.23.09-.23.05s.04-.05.11-.05Z'
                      />
                    </svg>
                  </div>
                </div>
              ) : null}
            </Link>
          </>
        );
      })}
    </div>
  );
}

export function buildBoxInfoTab(metaData) {
  // console.log('[buildBoxInfoTab] metaData', metaData)
  if (!metaData?.tab_box_info) return null;

  const generalSpecs = metaData?.tab_specifications?.value?.specs?.find(
    (x) => x?.title === 'General Specifications'
  );

  const type = (generalSpecs?.table?.Type || '').includes('Loaded') ? 'Loaded' : 'Empty';

  let size = Number(generalSpecs?.table?.['Subwoofer Size']?.replace('"', ''));

  let coilsType = ' D2/D4';
  if (type !== 'Loaded') {
    size = size > 0 ? '-' + size + coilsType : '';
  }

  const json =
    typeof metaData?.tab_box_info?.value === 'string'
      ? JSON.parse(metaData?.tab_box_info?.value)
      : metaData?.tab_box_info?.value;

  let boxInfo = json?.boxInfo;
  if (!Array.isArray(boxInfo)) {
    return;
  }

  return (
    <div>
      {boxInfo?.map(({title, table, notes}, index) => {
        // console.log("[buildBoxInfoTab] table", table, " [size]:", size, ' [title]:', title);

        return (
          <div key={index} className='mt-4 mb-2'>
            <Card>
              <div className='font-bold'>{title}</div>
              <SingleTableSpecifications json={table} keySuffix={size} type={type}/>
              <p className='italic'>{notes}</p>
            </Card>
          </div>
        );
      })}
    </div>
  );
  // return [<div>box info later </div>{...metaData?.tab_box_info} />];
}

export function buildInstallInfoTab(metaData) {
  if (!metaData?.tab_install) {
    return null;
  }

  const json =
    typeof metaData?.tab_install?.value === 'string'
      ? JSON.parse(metaData?.tab_install?.value)
      : metaData?.tab_install?.value;
  // console.log(json);
  let {install} = json;
  if (!Array.isArray(install)) {
    return;
  }

  return (
    <div>
      {/*<pre>{JSON.stringify(install, null, 2)}</pre>*/}
      {install?.map(({title, table}, index) => (
        <div key={index} className='mt-4 mb-2'>
          <Card>
            <h6 className='font-bold'>{title}</h6>
            <SingleTableSpecifications json={table}/>
          </Card>
        </div>
      ))}
    </div>
  );
  // return [<div>box info later </div>{...metaData?.tab_box_info} />];
}

export const processValue = (value) => {
  value = String(value)?.replace('^2', '<sup>2</sup>');
  value = String(value)?.replace('^3', '<sup>3</sup>');
  value = String(value)?.replace('ft3', 'ft<sup>3</sup>');

  const isPdf = value?.includes('.pdf');

  if (value?.startsWith('https://')) {
    const url = new URL(value);
    return `<a href="${url}"
		target="_blank"
		${isPdf ? 'title="Open this PDF Document in a new tab"' : 'title="Open this link in a new tab"'}
		${isPdf ? 'aria-label="Open PDF (opens in a new window)"' : 'aria-label="Open Download (opens in a new window)"'}
		aria-describedby="new-window-desc"
		style="text-decoration: underline;
		color: #1e6cfb">Download</a>`;
  }

  const asJson = tryJson(value);
  // console.log({asJson})
  if (asJson && Array.isArray(asJson)) {
    return Array.from(new Set(asJson)).join(' ');
  }
  return value;
};
